import React from "react";
import { SVG, IconProps } from "../SVG";
export const SpotPhoneMissed = ({
    spotColor = "#FCB5A9",
    color = "#13126C",
    strokeWidth = "2.2",
    ...props
}: IconProps) => (
    <SVG xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 40 40" {...props}>
        <g clipPath="url(#Spot=on,_Size=40_svg__a)">
            <path
                fill={spotColor}
                d="M4.857 17.78c1.738-5.087 7.916-9.787 13.373-11.594 5.482-1.818 11.979-.362 16.283 3.888 4.304 4.25 6.402 10.611 5.107 15.97-1.26 5.374-5.757 8.608-9.715 10.583-3.983 1.985-7.428 1.992-11.538.997-4.123-.96-8.301-2.541-10.448-6.26-2.147-3.72-4.824-8.487-3.062-13.584Z"
            />
            <path
                stroke={color}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={strokeWidth}
                d="m38.332 1.667-10 10m0-10 10 10m-1.666 16.532v5a3.332 3.332 0 0 1-3.633 3.334 32.983 32.983 0 0 1-14.383-5.117 32.5 32.5 0 0 1-10-10 32.984 32.984 0 0 1-5.117-14.45A3.333 3.333 0 0 1 6.85 3.333h5a3.333 3.333 0 0 1 3.333 2.866 21.4 21.4 0 0 0 1.167 4.684 3.333 3.333 0 0 1-.75 3.516l-2.117 2.117a26.666 26.666 0 0 0 10 10L25.6 24.4a3.333 3.333 0 0 1 3.516-.75 21.4 21.4 0 0 0 4.684 1.167 3.334 3.334 0 0 1 2.866 3.383Z"
            />
        </g>
        <defs>
            <clipPath id="Spot=on,_Size=40_svg__a">
                <path fill="#fff" d="M0 0h40v40H0z" />
            </clipPath>
        </defs>
    </SVG>
);
SpotPhoneMissed.displayName = "SpotPhoneMissed";
